import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import { Helmet } from "react-helmet-async";
import ShopInner from "../Components/Shop/ReturnOrder";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";

function Shop() {
  return (
    <>
      <Helmet>
        <title>Return Your Order | Printers Friendly</title>
      </Helmet>
      <HeaderOne />
      <ShopInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Shop;
